import { render, staticRenderFns } from "./mainDataAddr.vue?vue&type=template&id=970b5a14&scoped=true&"
import script from "./mainDataAddr.vue?vue&type=script&lang=js&"
export * from "./mainDataAddr.vue?vue&type=script&lang=js&"
import style0 from "./mainDataAddr.vue?vue&type=style&index=0&id=970b5a14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970b5a14",
  null
  
)

export default component.exports